import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { TerminalLifecycleRepository } from '@app/domain/ports/tpv/terminal-lifecycle.repository';
import { UpdateTerminalRequest } from '@app/data/dtos/tpv/terminal-update.dto';

/**
 * Mock del ciclo de vida de terminales para pruebas sin backend (toggle tpvUseMocks).
 * Simula latencia y siempre resuelve con éxito.
 */
@Injectable()
export class TerminalLifecycleMockDataSource extends TerminalLifecycleRepository {
  override updateTerminal(
    _idTerminal: string,
    _payload: UpdateTerminalRequest,
  ): Observable<void> {
    return of(void 0).pipe(delay(400));
  }

  override deleteTerminal(_idTerminal: string): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
}
